<template>
  <div
    v-if="shouldShowBanner && $globalVar.in_app_payments"
    class="ai-reason-bnr sp"
  >
    <button class="ai-reason-bnr-btn" @click="handleBannerClick">
      <span class="ai-reason-bnr-btn__icon">💡</span>
      <span class="ai-reason-bnr-btn__text">
        <strong class="ai-reason-bnr-btn__title">{{ title }}</strong>
        <span class="ai-reason-bnr-btn__desc">{{ description }}</span>
      </span>
    </button>
    <button @click="closeBtn" class="ai-reason-bnr-close-btn">×</button>
  </div>
</template>

<style lang="scss" scoped>
.ai-reason-bnr {
  button {
    background: none;
    cursor: pointer;
  }

  position: fixed;
  bottom: 10px;
  left: calc(50% - 160px);
  width: 320px;
  max-width: calc(100% - 20px);
  height: auto;
  z-index: 100;

  .ai-reason-bnr-btn {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 14px 16px;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 10px;
    box-shadow: 0px 0px 15px -5px #777777;
    text-align: left;

    &:hover {
      opacity: 1;
    }

    &__icon {
      flex-shrink: 0;
      font-size: 1.5rem;
      line-height: 1;
    }

    &__text {
      display: flex;
      flex-direction: column;
      gap: 2px;
    }

    &__title {
      font-size: 0.85rem;
      color: #333;
      line-height: 1.4;
    }

    &__desc {
      font-size: 0.8rem;
      color: #e3165c;
      font-weight: bold;
      line-height: 1.4;
    }
  }

  .ai-reason-bnr-close-btn {
    position: absolute;
    display: inline-block;
    top: -10px;
    right: 0;
    width: 25px;
    height: 25px;
    background: #dfdfdf;
    border: none;
    border-radius: 50%;
    font-size: 19px;
    text-align: center;
    cursor: pointer;
    color: #e3165c;
  }
}
</style>

<script>
export default {
  data() {
    return {
      // 70%の確率で表示するためのランダム値（初期化時に決定）
      showRandomly: Math.random() < 0.7
    }
  },
  computed: {
    bannerType() {
      const currentPath = this.$route.path
      if (/^\/format\/[^/]+\/edit\/reason$/.test(currentPath)) {
        return 'reason'
      }
      if (/^\/format\/[^/]+\/edit\/id-photo$/.test(currentPath)) {
        return 'id-photo'
      }
      return null
    },
    title() {
      return this.bannerType === 'reason'
        ? '志望動機で手が止まっていませんか？'
        : '背景、そのままになっていませんか？'
    },
    description() {
      return this.bannerType === 'reason'
        ? 'AIアシスタントが作成をサポートします'
        : '自撮り写真をアップロードするだけで背景を証明写真風に自動調整できます'
    },
    shouldShowBanner() {
      // YagiPrimeユーザーには表示しない
      if (this.$globalVar.isYagiPrime) {
        return false
      }
      if (!this.bannerType) {
        return false
      }
      // ランダムで表示対象の場合のみ表示
      return this.showRandomly
    }
  },
  methods: {
    closeBtn() {
      const element = document.querySelector('.ai-reason-bnr')
      element.style.display = 'none'
    },
    handleBannerClick() {
      if (this.bannerType === 'reason') {
        // ReasonCard.vueコンポーネントのAI文章作成ポップアップを表示するイベントを発火
        this.$eventHub.$emit('open-ai-reason-dialog')
      } else if (this.bannerType === 'id-photo') {
        // BasicInfo.vueの証明写真プライム訴求モーダルを表示するイベントを発火
        this.$eventHub.$emit('open-idphoto-prime-dialog')
      }
    }
  }
}
</script>
